import { render, staticRenderFns } from "./ModalRegraTeto.vue?vue&type=template&id=614c72f9&scoped=true"
import script from "./ModalRegraTeto.vue?vue&type=script&lang=ts"
export * from "./ModalRegraTeto.vue?vue&type=script&lang=ts"
import style0 from "./ModalRegraTeto.vue?vue&type=style&index=0&id=614c72f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "614c72f9",
  null
  
)

export default component.exports